var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"why-modal\" class=\"popup why-we\"><p>Your ID and account verification is required for compliance purposes to help avoid criminal activity and money laundering. The name you send us should be the full legal name of the person or company receiving the transfers. If an individual account is used, it should match the SSN. If a company name is used, it should match the name for the EIN.</p></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/payments/signup/bank_account_info/whyModal.jade
// module id = 764
// module chunks = 0